/**
 * 将提示词中可能出现的本地化媒体引用统一为后端约定的英文小写无方括号格式：
 *   @[图像1] / @[Image1] / @[image1] / @image1  -> @image1
 *   @[视频2] / @[Video2] / @[video2] / @video2  -> @video2
 *   @[音频3] / @[Audio3] / @[audio3] / @audio3  -> @audio3
 *
 * 兼容大小写、中文、英文、可选的方括号及末尾的数字序号。
 * 注：部分模型（如 Pixverse）不支持 ref_name 中包含 `[]`，因此这里统一去掉方括号。
 *
 * 带节点名字的 token（仅用于界面展示）会先去掉名字：@[图像1·海螺] -> @image1
 */
export function normalizeMentions(input: string): string {
    if (typeof input !== 'string' || input.length === 0) return input;
    return input
        .replace(/@\[([^\]\n·]*?\d+)\s*·[^\]\n]*\]/g, '@[$1]')
        .replace(/@\[?\s*(?:图像|图片|Image|image)\s*(\d+)\s*\]?/g, '@image$1')
        .replace(/@\[?\s*(?:视频|Video|video)\s*(\d+)\s*\]?/g, '@video$1')
        .replace(/@\[?\s*(?:音频|Audio|audio)\s*(\d+)\s*\]?/g, '@audio$1');
}
